import {
  UPDATE_MEMBER_STATUS,
  UPDATE_SPECIALIST_STATUS,
  UPDATE_WEBINAR_STATUS,
  UPDTAE_BLOG_STATUS,
  UPDTAE_FORUM_STATUS,
} from "../../utils/keywords";
import { handleUpdateWebinar } from "../../redux/admin-slices/webinars.slice";
import { hideDialog, refresher } from "../../redux/guest-slices/other.slice";
import { handleUpdateForum } from "../../redux/admin-slices/forums.slice";
import { updateBlog } from "../../redux/admin-slices/blogs.slice";
import { useDispatch, useSelector } from "react-redux";
import InputFieldA from "../ui/InputFieldA";
import Icons from "../../assets/js/Icons";
import { useRef } from "react";

import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { updateSpecialistStatus } from "../../redux/admin-slices/specialist.slice";
import { updateMembertStatus } from "../../redux/admin-slices/member.slice";
import { messages, titles } from "./data";

function Update() {
  const reasonRef = useRef();
  const dispatch = useDispatch();
  const { type, data, loadings } = useSelector((state) => state.otherSlice);
  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  // Handle update
  const handleUpdate = async (e) => {
    e.preventDefault();
    const reason = reasonRef?.current?.value;
    const deleteActions = {
      [UPDTAE_BLOG_STATUS]: () =>
        updateBlog({
          id: data?.blogId,
          formData: { reason, status: data?.status },
        }),
      [UPDTAE_FORUM_STATUS]: () =>
        handleUpdateForum({
          id: data?.forumId,
          formData: { reason, status: data?.status },
        }),
      [UPDATE_WEBINAR_STATUS]: () =>
        handleUpdateWebinar({
          id: data?.webinarId,
          formData: { reason, status: data?.status },
        }),
      [UPDATE_SPECIALIST_STATUS]: () =>
        updateSpecialistStatus({
          id: data?.specialistId,
          status: data?.status,
          reason: reason,
        }),
      [UPDATE_MEMBER_STATUS]: () =>
        updateMembertStatus({
          id: data?.memberId,
          status: data?.status,
          reason: reason,
        }),
    };

    const action = deleteActions[type];
    if (!action) return;
    dispatch(action())
      .unwrap()
      .then(() => {
        setTimeout(() => {
          handleClose();
          dispatch(refresher());
        }, 100);
      })
      .catch(() => { });
  };

  return (
    <Paper component="form" onSubmit={handleUpdate}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >{titles?.[type] || null}
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <Box sx={{ display: "grid", placeContent: "center", mb: 2 }}>
          <Icon
            sx={{ fontSize: "60px", overflow: "visible", color: "error.main" }}
          >
            <Icons.AlertStroke />
          </Icon>
        </Box>

        <Stack spacing={1}>
          <Typography
            sx={{
              m: "0",
              color: "#333333",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
              fontFamily: "Poppins",
            }}
          >{messages?.[type] || null}
          </Typography>
          {(data?.status === "rejected" || data?.status === false) && (
            <Box sx={{ label: { color: "other.color1" } }}>
              <InputFieldA
                name="reason"
                label="Reason"
                type="textarea"
                ref={reasonRef}
                placeholder="Enter the reason"
              />
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          type="submit"
          color="success"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={
            loadings?.update && (
              <CircularProgress
                size={20}
                thickness={5}
                sx={{ color: "white" }}
              />
            )
          }
        >
          Update
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default Update;
